import { useStoreLogger } from '@/logger.ts'
import {
  OrderDetailGet,
  OrderDetailGetListByCustomer,
  LiveOrderDetailGetList,
  PaidOrderDetailGetList
} from '@/api/Order'
import type {
  IOrderGetListResponse,
  IOrderDetailGetResponse
} from '@/types/OrderTypes.ts'
import type { FilterContainer } from '@/types/FilterTypes'

export async function LiveOrderGetList(beeNumber: number): Promise<IOrderGetListResponse> {
  const logger = useStoreLogger()
  logger.debug('LiveOrderGetList')
  const event = await LiveOrderDetailGetList({
    DatabaseFilter: {
      Where: {
        OperatorType: "And",
        Operands: [
          {
            Field: "BeeNumberOriginator",
            Value: beeNumber,
            FilterType: "Equal",
          },
        ],
      },
    },
  })
  return event
}

export async function CustomerOrderGetList(): Promise<IOrderGetListResponse> {
  const logger = useStoreLogger()
  logger.debug('CustomerOrderGetList')
  const event = await OrderDetailGetListByCustomer()
  return event
}

// The consultant is taken from the session by the connector, so only the
// search the user built in the grid is sent
export async function PaidOrderGetList(databaseFilter: FilterContainer): Promise<IOrderGetListResponse> {
  const logger = useStoreLogger()
  logger.debug('PaidOrderGetList')
  const event = await PaidOrderDetailGetList(
    databaseFilter.Where ? { DatabaseFilter: databaseFilter } : {}
  )
  return event
}

export async function GetOrderDetail(aoeOrderIdToken: string): Promise<IOrderDetailGetResponse> {
  const logger = useStoreLogger()
  logger.debug('GetOrderDetail', aoeOrderIdToken)
  const event = await OrderDetailGet(aoeOrderIdToken)
  return event
}
